export interface WidgetData {
  id: string;
  type: WidgetType;
  title: string;
  value: string | number | any[];
  previous?: string | number;
  subtitle?: string;
  description?: string;
  thresholds?: {
    warning: number;
    attention: number;
  };
  maxValue?: number;
  layout?: GridItemLayout;
  styleConfig?: {
    color?: string;
    fontSize?: number;
    fontWeight?: string;
    backgroundColor?: string;
    borderRadius?: number;
    headerFontSize?: number;
    valueFontSize?: number;
    subtitleFontSize?: number;
    descriptionFontSize?: number;
    iconSize?: number;
    valueColor?: string;
    subtitleColor?: string;
    descriptionColor?: string;
  };
  icon?: React.ReactNode;
}

export interface GridItemLayout {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
}

export enum WidgetType {
  CALL_VOLUMES = "callVolumes",
  CALL_WAIT_TIME = "callWaitTime",
  AGENT_AVAILABILITY = "agentAvailability",
  CALLS_IN_QUEUE = "callsInQueue",
  AGENT_DAILY_CALLS = "agentDailyCalls",
  AGENT_PRESENCE = "agentPresence",
  AGENT_PERFORMANCE = "agentPerformance",
  AGENT_PERFORMANCE_SLA = "agentPerformanceSLA",
  AGENT_STATUS_OVER_TIME = "agentStatusOverTime",
  AGENT_PERFORMANCE_TABLE = "agentPerformanceTable",
  AGENT_STATUS = "agentStatus",
  ABANDONED_RATE = "abandonedRate",
  CALL_VOLUME_TOTAL = "callVolumeTotal",
  CALL_JOURNEY = "callJourney",
  INBOUND_STATUS_DISTRIBUTION = "inboundStatusDistribution",
  OUTBOUND_STATUS_DISTRIBUTION = "outboundStatusDistribution",
  CALLS_HANDLED_BY_QUEUE = "callsHandledByQueue",
  AVG_HANDLING_TIME = "avgHandlingTime",
  AVG_SPEED_OF_ANSWER = "avgSpeedOfAnswer",
  AVG_WAITING_TIME = "avgWaitingTime",
  SLA_RANKING = "slaRanking",
  CALL_DETAILS = "callDetails",
}

export interface DashboardLayout {
  id: string;
  widgets: WidgetData[];
  layouts: GridItemLayout[];
  name?: string;
}

export interface WidgetSettingsFormData {
  name: string;
  interval: string;
  type: string;
  warningThreshold: number;
  attentionThreshold: number;
  maxValue: number;
}

// Re-export filter types
export * from './filter';
